const ttl = process.env.VUE_APP_CONTENT_CACHE_TTL

export default {
  methods: {
    resourceReadAt(resource) {
      return resource.__read_at
    },

    resourceStale(date) {
      if (!date) {
        return true
      }

      return Date.now() - date > ttl
    }
  }
}
